import { render, staticRenderFns } from "./OrdersList.vue?vue&type=template&id=6649ce12&scoped=true&"
import script from "./OrdersList.vue?vue&type=script&lang=js&"
export * from "./OrdersList.vue?vue&type=script&lang=js&"
import style0 from "./OrdersList.vue?vue&type=style&index=0&id=6649ce12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6649ce12",
  null
  
)

export default component.exports